import React from 'react'
import {CFXProFormatNumber} from './formatting'

export const reactTableColumn = (
  header,
  accessor,
  className = '',
  callback = null,
) => {
  const cellCallback = callback
    ? callback
    : (cell) => (
        <div className="cell-value">
          {CFXProFormatNumber(
            cell.value,
            cell.original.roundTo != null ? cell.original.roundTo : 2,
          )}
        </div>
      )

  return {
    Header: header,
    accessor: accessor,
    className: className,
    Cell: cellCallback,
  }
}



// WEBPACK FOOTER //
// ./src/helpers/reactTable.js